<template>
    <div class="flex flex-wrap items-end gap-4 mb-5">
        <div class="flex flex-col">
            <label for="orders_date_from" class="text-sm font-medium text-gray-700">From</label>
            <input id="orders_date_from" type="date" v-model="dateFrom" class="mt-1 block rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>

        <div class="flex flex-col">
            <label for="orders_date_to" class="text-sm font-medium text-gray-700">To</label>
            <input id="orders_date_to" type="date" v-model="dateTo" class="mt-1 block rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>

        <button v-if="dateFrom || dateTo" type="button" @click="clearDateFilter" class="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
            Clear
        </button>
    </div>

    <div class="flex items-center space-x-2 mb-5" v-if="selectedLeads.length">
        <button @click="submit" type="button" class="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 ">Close leads</button>

        <div class="relative inline-block text-left">
            <div>
                <button @click="showDropdown = !showDropdown" type="button" class="inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-1 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-100"  aria-expanded="true" aria-haspopup="true">
                    Mark Leads
                    <svg class="-mr-1 ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>

            <div v-if="showDropdown" class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                <div class="py-1" role="none">
                    <span @click="markLead('won')" class="text-green-500 block px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer" role="menuitem" tabindex="-1">Won</span>
                    <span @click="markLead('lost')" class="text-red-500 block px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer border-b border-gray-300" role="menuitem" tabindex="-1">Lost</span>
                    <span @click="markLead('incorrect_details')" class="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer" role="menuitem" tabindex="-1">Incorrect Details</span>
                    <span @click="markLead('out_of_area')" class="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer" role="menuitem" tabindex="-1">Out of Area</span>
                    <span @click="markLead('quote_sent')" class="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer" role="menuitem" tabindex="-1">Quote Sent</span>
                    <span @click="markLead('spam')" class="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer" role="menuitem" tabindex="-1">Spam</span>
                    <span @click="markLead('unable_to_contact')" class="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer" role="menuitem" tabindex="-1">Unable to Contact</span>
                    <span @click="markLead('waiting_on_customer')" class="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer" role="menuitem" tabindex="-1">Waiting on Customer</span>
                </div>
            </div>
        </div>
    </div>

    <div class="overflow-x-auto shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
        <table class="min-w-full divide-y divide-gray-300">
            <thead class="bg-gray-50">
            <tr>
                <th scope="col" class="relative px-7 sm:w-12 sm:px-6">
                    <input type="checkbox" v-model="selectAll" :value="!selectAll" :checked="selectAll" class="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600">
                </th>
                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Customer</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Email</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Phone</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Type</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Assigned To</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Status</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Date</th>
            </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white">
                <tr :class="{'bg-gray-50': isLeadSelected(lead.id)}" v-for="(lead, index) in leads_data">
                    <td class="relative px-7 sm:w-12 sm:px-6">
                        <div v-if="isLeadSelected(lead.id)" class="absolute inset-y-0 left-0 w-0.5 bg-indigo-600"></div>
                        <input type="checkbox" v-model="selectedLeads" :value="lead.id" :checked="isLeadSelected(lead.id)" class="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600">
                    </td>
                    <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 hover:text-blue-500" :class="{'text-indigo-600': isLeadSelected(lead.id)}">
                        <a :href="'/leads/'+lead.reference">{{ lead.customer.name }}</a>
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{ lead.customer.email }}</td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{ lead.customer.phone }}</td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{ lead.name }}</td>
                    <td class="whitespace-nowrap px-3 py-4 text-xs text-gray-500">
                        <ul v-if="lead.assigned_to.length">
                            <li v-for="(installer, index) in lead.assigned_to">{{ installer }}</li>
                        </ul>
                        <span v-else>-</span>
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-left">
                        <span
                            class="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold"
                            :style="getStatusClasses(lead.status).style"
                        >
                            <svg class="h-2 w-2" :style="getStatusClasses(lead.status).dotStyle" viewBox="0 0 8 8"><circle cx="4" cy="4" r="3" /></svg>
                            {{ lead.status.replaceAll('_', ' ') }}
                        </span>
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{ lead.date }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="flex items-center justify-between mt-4 px-4 py-3 sm:px-6" v-if="pagination.total > pagination.per_page">
        <div class="flex flex-1 justify-between sm:hidden">
            <button @click="fetch(pagination.current_page - 1)" :disabled="!pagination.prev_page_url" class="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">Previous</button>
            <button @click="fetch(pagination.current_page + 1)" :disabled="!pagination.next_page_url" class="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">Next</button>
        </div>
        <div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
            <div>
                <p class="text-sm text-gray-700">
                    Showing
                    <span class="font-medium">{{ pagination.from }}</span>
                    to
                    <span class="font-medium">{{ pagination.to }}</span>
                    of
                    <span class="font-medium">{{ pagination.total }}</span>
                    results
                </p>
            </div>
            <div>
                <nav class="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
                    <template v-for="(link, key) in pagination.links">
                        <button
                            v-if="link.url"
                            :key="key"
                            @click="fetch(getPageFromUrl(link.url))"
                            class="relative inline-flex items-center px-4 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0"
                            :class="{'z-10 bg-indigo-600 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600': link.active, 'text-gray-900 hover:bg-gray-50': !link.active, 'rounded-l-md': key === 0, 'rounded-r-md': key === pagination.links.length - 1}"
                            v-html="link.label"
                        ></button>
                        <span
                            v-else
                            :key="'span-'+key"
                            class="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300 focus:outline-offset-0"
                            :class="{'rounded-l-md': key === 0, 'rounded-r-md': key === pagination.links.length - 1}"
                            v-html="link.label"
                        ></span>
                    </template>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['leads'],
    data() {
        return {
            dateFrom: '',
            dateTo: '',
            selectedLeads: [],
            selectAll: false,
            leads_data: this.leads.data || this.leads,
            pagination: this.leads.data ? this.leads : {},
            showDropdown: false,
            statusClasses: {
                open: { style: { backgroundColor: '#dbeafe', color: '#1d4ed8', boxShadow: 'inset 0 0 0 1px rgba(29, 78, 216, 0.1)' }, dotStyle: { fill: '#3b82f6' } },
                won: { style: { backgroundColor: '#dcfce7', color: '#15803d', boxShadow: 'inset 0 0 0 1px rgba(22, 163, 74, 0.2)' }, dotStyle: { fill: '#22c55e' } },
                lost: { style: { backgroundColor: '#fee2e2', color: '#b91c1c', boxShadow: 'inset 0 0 0 1px rgba(220, 38, 38, 0.1)' }, dotStyle: { fill: '#ef4444' } },
                closed: { style: { backgroundColor: '#f3f4f6', color: '#4b5563', boxShadow: 'inset 0 0 0 1px rgba(107, 114, 128, 0.1)' }, dotStyle: { fill: '#9ca3af' } },
                quote_sent: { style: { backgroundColor: '#e0e7ff', color: '#4338ca', boxShadow: 'inset 0 0 0 1px rgba(67, 56, 202, 0.1)' }, dotStyle: { fill: '#6366f1' } },
                incorrect_details: { style: { backgroundColor: '#ffedd5', color: '#c2410c', boxShadow: 'inset 0 0 0 1px rgba(234, 88, 12, 0.2)' }, dotStyle: { fill: '#f97316' } },
                out_of_area: { style: { backgroundColor: '#f3f4f6', color: '#4b5563', boxShadow: 'inset 0 0 0 1px rgba(107, 114, 128, 0.1)' }, dotStyle: { fill: '#9ca3af' } },
                spam: { style: { backgroundColor: '#fee2e2', color: '#b91c1c', boxShadow: 'inset 0 0 0 1px rgba(220, 38, 38, 0.1)' }, dotStyle: { fill: '#ef4444' } },
                unable_to_contact: { style: { backgroundColor: '#fef9c3', color: '#854d0e', boxShadow: 'inset 0 0 0 1px rgba(202, 138, 4, 0.2)' }, dotStyle: { fill: '#eab308' } },
                waiting_on_customer: { style: { backgroundColor: '#fef3c7', color: '#b45309', boxShadow: 'inset 0 0 0 1px rgba(217, 119, 6, 0.2)' }, dotStyle: { fill: '#f59e0b' } },
                appointment_made: { style: { backgroundColor: '#ccfbf1', color: '#0f766e', boxShadow: 'inset 0 0 0 1px rgba(15, 118, 110, 0.1)' }, dotStyle: { fill: '#14b8a6' } },
            },
        }
    },
    watch: {
        dateFrom() {
            this.fetch(1);
        },
        dateTo() {
            this.fetch(1);
        },
        selectAll() {
            this.selectedLeads = this.selectAll ? this.leads_data.map(lead => lead.id) : [];
        }
    },
    computed: {

    },
    methods: {
        fetch(page = 1) {
            axios.get('/leads/fetch', {
                params: {
                    page,
                    date_from: this.dateFrom || undefined,
                    date_to: this.dateTo || undefined,
                },
            }).then(response => {
                if (response.data.leads) {
                    this.leads_data = response.data.leads.data;
                    this.pagination = response.data.leads;
                    this.selectAll = false;
                }
            })
        },
        clearDateFilter() {
            this.dateFrom = '';
            this.dateTo = '';
            this.fetch(1);
        },
        getPageFromUrl(url) {
            if (!url) return 1;
            let paramString = url.split('?')[1];
            let queryString = new URLSearchParams(paramString);
            return queryString.get('page');
        },
        submit() {
            axios.patch('/leads', {
                bulk_close: true,
                selected_leads: this.selectedLeads,
            }).then(response => {
                this.fetch(this.pagination.current_page);
                this.selectedLeads = [];
            }).catch(error => {
                //
            })
        },
        markLead(status) {
            axios.patch('/leads', {
                bulk_close: true,
                status: status,
                close_lead: 'true',
                selected_leads: this.selectedLeads,
            }).then(response => {
                this.fetch(this.pagination.current_page);
                this.selectedLeads = [];
            }).catch(error => {
                console.log('Error marking leads:', error);
            })
        },
        isLeadSelected(id) {
            return this.selectedLeads.includes(id)
        },
        getStatusClasses(status) {
            const normalizedStatus = status ? status.toLowerCase().trim() : '';
            return this.statusClasses[normalizedStatus] || this.statusClasses[status] || { style: { backgroundColor: '#f3f4f6', color: '#4b5563', boxShadow: 'inset 0 0 0 1px rgba(107, 114, 128, 0.1)' }, dotStyle: { fill: '#9ca3af' } };
        }
    }
}
</script>
